import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import snackbar from '@/_containers/snackbar-actions';
import { getFriendlyMessageForApis } from '@/_shared';

type TApiLikeError = {
  data?: {
    code?: string;
    [key: string]: unknown;
  };
  error?: string;
  [key: string]: unknown;
};

function handleQueryError(error: unknown) {
  try {
    const payload = (error ?? {}) as TApiLikeError;
    if (payload?.data?.code === 'token_not_valid') {
      return;
    }

    const { msg } = getFriendlyMessageForApis(payload, { message: payload?.error ?? '' });

    if (msg && msg !== 'You are allowed to accept hardship only once in a year.') {
      snackbar.error(msg, { toastId: msg });
    }
  } catch (e) {
    console.log(e);
    const msg = 'catch: System failure, Please contact support team.';
    snackbar.error(msg, { toastId: msg });
  }
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: handleQueryError,
  }),
  mutationCache: new MutationCache({
    onError: handleQueryError,
  }),
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
    mutations: {
      retry: false,
    },
  },
});
